import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-info">
            <div className="footer-brand">
              <div className="footer-logo-icon">P</div>
              <span className="footer-logo-text">Telegram<span>PRIME</span></span>
            </div>
            <p className="footer-desc">{t('footer.desc')}</p>
          </div>

          <div className="footer-contacts">
            <h4>{t('nav.contacts')}</h4>
            <p className="footer-support">{t('footer.support')}</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            &copy; {new Date().getFullYear()} Telegram PRIME. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;